import { render, staticRenderFns } from "./AlertViewSidebar.vue?vue&type=template&id=51c3fc84&scoped=true&"
import script from "./AlertViewSidebar.vue?vue&type=script&lang=js&"
export * from "./AlertViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AlertViewSidebar.vue?vue&type=style&index=0&id=51c3fc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3fc84",
  null
  
)

export default component.exports